import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import FiniteStateConfigListing from './FiniteStateConfigListing'
import FiniteStateCredentialsForm from './FiniteStateCredentialsForm'

export default function FiniteStatePullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={FiniteStateCredentialsForm}
            PullConfigListingView={FiniteStateConfigListing}
        />
    )
}
